import { Component, OnInit } from '@angular/core';
import Category from '../../../models/category';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigate(category?: Category | null) {
    const hash = category?.name.toLowerCase() ?? 'todos';
    this.router.navigate([`/events/${hash}`]);
  }

  protected readonly environment = environment;
}
